import { React } from 'react';
import styled from 'styled-components';
import PartnerGymMemberDetailView from '../../Model/Individual/MemberModel/MemberDetail/PartnerGymMemberDetailView';


export default function PartnerGymMemberDetailPage({match}) {

  return (
    <Container>
      <PartnerGymMemberDetailView memberId={match.params.memberId} division={match.params.division}/>
      {/* <PartnerGymMemberDetailView */}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;